import { pathname } from "#src/config/pathname";
import { Trans, useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export const Error403Content = () => {
  const { t } = useTranslation("common", {
    keyPrefix: "errors",
  });

  return (
    <>
      <Link to={"http://bit.ly/3REFG7M"} className="relative w-40 h-40">
        <iframe
          src="https://giphy.com/embed/Ju7l5y9osyymQ"
          width="100%"
          height="100%"
          className="absolute top-0 left-0"
          allowFullScreen
        ></iframe>
      </Link>
      {t("noPermission")}
      <p>
        <Trans
          t={t}
          i18nKey={"clickHereToHome"}
          components={{
            a: <Link to={pathname.HOME} className="contents"></Link>,
          }}
        />
      </p>
    </>
  );
};
